
const enum CommentType {
    'None',
    'Info',
    'Warning',
    'Problem',
    'Success'

};
import { Marketdate } from '../marketdate';
import { User } from '../../shared';
export class MarketdateComment {
    constructor(
        public id?: number,
        public comment?: string,
        public commentType?: CommentType,
        public updated?: any,
        public created?: any,
        public marketdate?: Marketdate,
        public updatedBy?: User,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-comment/marketdate-comment.model.ts